function getStaticUsers() {
    const staticUsers = [
        {
            "id": 113206,
            "uid": 4963424227950833,
            "name": "GerO26",
            "avatar": "https://static.shihuocdn.cn/r_avatar/9d4d450cc563600355e87fc36eed1e58.png",
            "comment": "361飞燃2.5海绵宝宝39码还会有货吗",
            "like_cnt": 16,
            "self_like": false,
            "is_self": 0,
            "create_at": "2023-10-27 13:55:37"
        },
        {
            "id": 113202,
            "uid": 18989229,
            "name": "蓝上了",
            "avatar": "https://static.shihuocdn.cn/app/avatar/156264186610312.jpg",
            "comment": "近一年的国产实战鞋，只买一双，买哪双？",
            "like_cnt": 15,
            "self_like": false,
            "is_self": 0,
            "create_at": "2023-10-26 18:39:29"
        },
        {
            "id": 113204,
            "uid": 4077697501036699,
            "name": "老式卫生纸",
            "avatar": "https://static.shihuocdn.cn/third_avatar/9NSd9cMch6c44413f8748c5065d7f41ffbb3e30e47",
            "comment": "双十一韦德之道10最低多少",
            "like_cnt": 13,
            "self_like": false,
            "is_self": 0,
            "create_at": "2023-10-27 10:20:40"
        },
        {
            "id": 113277,
            "uid": 4712900251451559,
            "name": "54455454",
            "avatar": "https://static.shihuocdn.cn/photo/20230628/1000x1000_80c6a07e-3980-4fac-856c-672ca0cfaa65.jpeg",
            "comment": "鞋子推荐",
            "like_cnt": 8,
            "self_like": false,
            "is_self": 0,
            "create_at": "2023-10-29 20:31:59"
        },
        {
            "id": 113487,
            "uid": 4499326372217003,
            "name": "J-36",
            "avatar": "https://static.shihuocdn.cn/user/avatar/photo/20231001/1036x1036_a127d920-790e-4b05-b6d3-43c7335ea6f7.jpeg",
            "comment": "李宁闪击9TD卯兔会降价嘛？",
            "like_cnt": 3,
            "self_like": false,
            "is_self": 0,
            "create_at": "2023-11-03 23:46:49"
        },
        {
            "id": 113334,
            "uid": 5341950864752827,
            "name": "勇敢的心V7Z",
            "avatar": "https://static.shihuocdn.cn/r_avatar/8f6d2cd41de1d838dd0f555c0c074517.png",
            "comment": "【双十一必抢】Air Jordan Legacy 312  气垫缓震 休闲鞋 GS/灰色/蓝色双11会降价吗",
            "like_cnt": 3,
            "self_like": false,
            "is_self": 0,
            "create_at": "2023-10-31 20:51:44"
        },
        {
            "id": 113620,
            "uid": 4790241454424153,
            "name": "墨海马I4i",
            "avatar": "https://static.shihuocdn.cn/r_avatar/d17ebc8985408f95283752f5ae38597d.png",
            "comment": "利刃4手高有券吗",
            "like_cnt": 2,
            "self_like": false,
            "is_self": 0,
            "create_at": "2023-11-10 22:12:34"
        },
        {
            "id": 113262,
            "uid": 5273434773389416,
            "name": "虚空恐惧i5D",
            "avatar": "https://static.shihuocdn.cn/r_avatar/c3729e0be83fad9d85340a81023da0de.png",
            "comment": "买乔丹篮球鞋300以内有啥",
            "like_cnt": 2,
            "self_like": false,
            "is_self": 0,
            "create_at": "2023-10-29 08:43:38"
        },
        {
            "id": 113241,
            "uid": 4974127306014841,
            "name": "穿山王37s",
            "avatar": "https://static.shihuocdn.cn/r_avatar/917d9df1f8aa5ce6187f5412e7ab629a.png",
            "comment": "双十一买鞋1400能优惠多少？",
            "like_cnt": 2,
            "self_like": false,
            "is_self": 0,
            "create_at": "2023-10-28 15:06:14"
        },
        {
            "id": 113203,
            "uid": 4210504300265656,
            "name": "徐酒岁",
            "avatar": "https://static.shihuocdn.cn//20230908/287x287_689C8F80-95D2-4304-B472-15B878F00ED4.jpg",
            "comment": "有没有便宜的美白面霜推荐",
            "like_cnt": 2,
            "self_like": false,
            "is_self": 0,
            "create_at": "2023-10-27 10:03:44"
        },
        {
            "id": 113694,
            "uid": 5371950750498838,
            "name": "kyrie142",
            "avatar": "https://static.shihuocdn.cn/third_avatar/92rLl8FAA0e7a66942731b77b0f986dad08594179a",
            "comment": "双十一活动什么时候结束",
            "like_cnt": 1,
            "self_like": false,
            "is_self": 0,
            "create_at": "2023-11-11 22:40:33"
        },
        {
            "id": 113687,
            "uid": 5289907274023009,
            "name": "JulieN16",
            "avatar": "https://static.shihuocdn.cn/r_avatar/eea244345485e26f86d442922f8ad9e3.png",
            "comment": "打底衫",
            "like_cnt": 1,
            "self_like": false,
            "is_self": 0,
            "create_at": "2023-11-11 21:08:23"
        },
        {
            "id": 113682,
            "uid": 4977412455268495,
            "name": "北奕w",
            "avatar": "https://static.shihuocdn.cn/user/avatar/photo/20231111/1307x1307_68f4d0d6-6dc2-49f9-9f4d-4339aeddf9e0.jpeg",
            "comment": "利刃3V2",
            "like_cnt": 1,
            "self_like": false,
            "is_self": 0,
            "create_at": "2023-11-11 19:12:43"
        },
        {
            "id": 113641,
            "uid": 5276253337387233,
            "name": "world214",
            "avatar": "https://static.shihuocdn.cn/third_avatar/T91F0FyNmD2de1345fed077f293c6d805cedd7ef9b",
            "comment": "361飞燃2鸳鸯在双十一能降到四百吗",
            "like_cnt": 1,
            "self_like": false,
            "is_self": 0,
            "create_at": "2023-11-11 07:31:38"
        },
        {
            "id": 113617,
            "uid": 4409647165472931,
            "name": "腌鲜鳜鱼I0X",
            "avatar": "https://static.shihuocdn.cn/app/avatarbg/20230116/450e6d05-e1de-4b18-bd02-ff6af573368c.jpg",
            "comment": "跑鞋",
            "like_cnt": 1,
            "self_like": false,
            "is_self": 0,
            "create_at": "2023-11-10 21:54:33"
        },
        {
            "id": 113610,
            "uid": 5312066478211206,
            "name": "倒带e5g",
            "avatar": "https://static.shihuocdn.cn/r_avatar/725555e49ed46985ddec29dd09d33425.png",
            "comment": "38.5码的板鞋可以穿多少码的跑鞋",
            "like_cnt": 1,
            "self_like": false,
            "is_self": 0,
            "create_at": "2023-11-10 18:49:44"
        },
        {
            "id": 113557,
            "uid": 5339354360643606,
            "name": "身骑白马q1Q",
            "avatar": "https://static.shihuocdn.cn/r_avatar/5be71ab39981a5b9ba6b71fde117939b.png",
            "comment": "150篮球鞋",
            "like_cnt": 1,
            "self_like": false,
            "is_self": 0,
            "create_at": "2023-11-06 22:10:36"
        },
        {
            "id": 113519,
            "uid": 4877112288313386,
            "name": "赛车蓝841",
            "avatar": "https://static.shihuocdn.cn/third_avatar/0sPBvtIDTX3cc69876325a7932a175651c3d9f7a2a",
            "comment": "双11韦德之道8083代u最低多少钱",
            "like_cnt": 1,
            "self_like": false,
            "is_self": 0,
            "create_at": "2023-11-05 07:28:55"
        },
        {
            "id": 113509,
            "uid": 4879548387754156,
            "name": "玛奇朵39m",
            "avatar": "https://static.shihuocdn.cn/r_avatar/a01e86d4486d1839baecfea2cd944584.png",
            "comment": "跑鞋",
            "like_cnt": 1,
            "self_like": false,
            "is_self": 0,
            "create_at": "2023-11-04 21:02:04"
        },
        {
            "id": 113493,
            "uid": 5351757556219913,
            "name": "解救66a",
            "avatar": "https://static.shihuocdn.cn/r_avatar/24bf248e27f66550a64cd9589c5e58bb.png",
            "comment": "识货什么时候买便宜",
            "like_cnt": 1,
            "self_like": false,
            "is_self": 0,
            "create_at": "2023-11-04 11:10:45"
        },
        {
            "id": 113478,
            "uid": 4039500239994910,
            "name": "purpB3Y",
            "avatar": "https://static.shihuocdn.cn/third_avatar/MHPXnLM5SV9bb32672e84b9e5074e3d0610cdbff46",
            "comment": "羽毛球拍100左右",
            "like_cnt": 1,
            "self_like": false,
            "is_self": 0,
            "create_at": "2023-11-03 22:12:26"
        },
        {
            "id": 113442,
            "uid": 82318839,
            "name": "Ki___11",
            "avatar": "https://static.shihuocdn.cn/wx_user/avatar/1603898759/f1db4527ea6f30e186f561f103f240ea",
            "comment": "冬季鞋",
            "like_cnt": 1,
            "self_like": false,
            "is_self": 0,
            "create_at": "2023-11-03 14:32:07"
        },
        {
            "id": 113437,
            "uid": 5347348560969750,
            "name": "白雾zL1",
            "avatar": "https://static.shihuocdn.cn/third_avatar/0LVajLtxGG1012677334ba7e7bcbbf606ec6963d43",
            "comment": "碳板跑鞋买哪双",
            "like_cnt": 1,
            "self_like": false,
            "is_self": 0,
            "create_at": "2023-11-03 12:25:58"
        },
        {
            "id": 113436,
            "uid": 5347348560969750,
            "name": "白雾zL1",
            "avatar": "https://static.shihuocdn.cn/third_avatar/0LVajLtxGG1012677334ba7e7bcbbf606ec6963d43",
            "comment": "碳板跑鞋买哪双",
            "like_cnt": 1,
            "self_like": false,
            "is_self": 0,
            "create_at": "2023-11-03 12:25:56"
        },
        {
            "id": 113418,
            "uid": 3989539601875122,
            "name": "你说我笨幼稚",
            "avatar": "https://static.shihuocdn.cn/user/avatar/photo/20231105/997x997_c660adf5-9119-4cb0-975e-357513f7a24e.jpeg",
            "comment": "飞燃哪个系列好",
            "like_cnt": 1,
            "self_like": false,
            "is_self": 0,
            "create_at": "2023-11-02 22:37:12"
        },
        {
            "id": 113404,
            "uid": 5141627667939380,
            "name": "信使鸟g2t",
            "avatar": "https://static.shihuocdn.cn/r_avatar/056e4b9fb5a603202e74e3439621983b.png",
            "comment": "冬天穿小码推荐",
            "like_cnt": 1,
            "self_like": false,
            "is_self": 0,
            "create_at": "2023-11-02 20:20:38"
        },
        {
            "id": 113398,
            "uid": 3854637217218665,
            "name": "earthQ9u",
            "avatar": "https://static.shihuocdn.cn/third_avatar/QMSGUy7wkU53c5914b925ee4261dd75394576213aa",
            "comment": "李宁板鞋",
            "like_cnt": 1,
            "self_like": false,
            "is_self": 0,
            "create_at": "2023-11-02 18:16:37"
        },
        {
            "id": 113393,
            "uid": 3708896448741489,
            "name": "果冻茄",
            "avatar": "https://static.shihuocdn.cn/photo/20230407/962x962_ea0fa03c-9eb8-4625-8879-18a0322fe01f.jpeg",
            "comment": "护肤品",
            "like_cnt": 1,
            "self_like": false,
            "is_self": 0,
            "create_at": "2023-11-02 12:51:28"
        },
        {
            "id": 113275,
            "uid": 4802166735077502,
            "name": "七姐gQ3",
            "avatar": "https://static.shihuocdn.cn/third_avatar/cXFKAVk3by13e718226b6c1228bcdafcce7ee39ac8",
            "comment": "二手手机",
            "like_cnt": 1,
            "self_like": false,
            "is_self": 0,
            "create_at": "2023-10-29 19:40:52"
        },
        {
            "id": 113251,
            "uid": 4939673212092577,
            "name": "火焰鸟31d",
            "avatar": "https://static.shihuocdn.cn/r_avatar/e929815760001e6a20e288c101f29796.png",
            "comment": "350买什么跑步鞋",
            "like_cnt": 1,
            "self_like": false,
            "is_self": 0,
            "create_at": "2023-10-28 19:46:25"
        },
        {
            "id": 113247,
            "uid": 5140855129735278,
            "name": "狂潮86D",
            "avatar": "https://static.shihuocdn.cn/r_avatar/87b3bd8819707c85db9f8d8d494fbd41.png",
            "comment": "碳板路跑鞋",
            "like_cnt": 1,
            "self_like": false,
            "is_self": 0,
            "create_at": "2023-10-28 18:18:12"
        },
        {
            "id": 113226,
            "uid": 5239121308483808,
            "name": "武林萌娃rG4",
            "avatar": "https://static.shihuocdn.cn/third_avatar/8VKUn52hYsd249c06d5b979981096bc3f38b3a3202",
            "comment": "飞电3c",
            "like_cnt": 1,
            "self_like": false,
            "is_self": 0,
            "create_at": "2023-10-27 22:48:38"
        },
        {
            "id": 113224,
            "uid": 4232074838343755,
            "name": "樱花宝c4n",
            "avatar": "https://static.shihuocdn.cn/r_avatar/3288d63ac05feee7312858049e45cecc.png",
            "comment": "毒牙2.0怎么样",
            "like_cnt": 1,
            "self_like": false,
            "is_self": 0,
            "create_at": "2023-10-27 22:30:19"
        },
        {
            "id": 113210,
            "uid": 4218087308099659,
            "name": "懒人翁o6P",
            "avatar": "https://static.shihuocdn.cn/r_avatar/f58cc023ce4ced3dd731e144ea724445.png",
            "comment": "312",
            "like_cnt": 1,
            "self_like": false,
            "is_self": 0,
            "create_at": "2023-10-27 18:06:43"
        },
        {
            "id": 113205,
            "uid": 67820559,
            "name": "ccc32",
            "avatar": "https://static.shihuocdn.cn/wx_user/avatar/1585584248/f0c5712a01178bccec4820ea831b4b62",
            "comment": "有无性价比高点的护头皮洗发水 痒死了",
            "like_cnt": 1,
            "self_like": false,
            "is_self": 0,
            "create_at": "2023-10-27 10:31:01"
        },
        {
            "id": 113201,
            "uid": 87414294,
            "name": "精致君君",
            "avatar": "https://proxy.shihuocdn.cn/aHR0cHM6Ly90aGlyZHd4LnFsb2dvLmNuL21tb3Blbi92aV8zMi9mSUtHZ2xpYklIemJGbXBpYWljUFlqTXo2V0RzM09pY2ZCWWF0dzd3ektZbXkzQTZXRE9LUE9jS1RuM0lZWDlIWWljc1VHZll5Smx5VlRuQmtNVk5PZUlGakx3LzEzMg..",
            "comment": "不知道买啥衣服",
            "like_cnt": 1,
            "self_like": false,
            "is_self": 0,
            "create_at": "2023-10-26 15:23:16"
        },
        {
            "id": 113698,
            "uid": 5358420086390982,
            "name": "manrS6",
            "avatar": "https://static.shihuocdn.cn/third_avatar/4qRojZFy2Qc6e3f956698d4ac634583771c67b6a99",
            "comment": "aj买那个",
            "like_cnt": 0,
            "self_like": false,
            "is_self": 0,
            "create_at": "2023-11-11 23:56:34"
        },
        {
            "id": 113697,
            "uid": 61757746,
            "name": "gqs12834",
            "avatar": "https://static.shihuocdn.cn/qqlogin/avatar/1579328745/1f1a3094d9430c0a6fa2b0936eba186f",
            "comment": "卫衣",
            "like_cnt": 0,
            "self_like": false,
            "is_self": 0,
            "create_at": "2023-11-11 23:55:31"
        },
        {
            "id": 113696,
            "uid": 3575027306070048,
            "name": "叁拾N",
            "avatar": "https://static.shihuocdn.cn/photo/20230208/1016x1016_4b0bb157-1712-43ce-b158-d3b26a57b2cc.jpeg",
            "comment": "百元跑鞋",
            "like_cnt": 0,
            "self_like": false,
            "is_self": 0,
            "create_at": "2023-11-11 23:08:23"
        },
        {
            "id": 113695,
            "uid": 5371669516746989,
            "name": "墨海马H8b",
            "avatar": "https://static.shihuocdn.cn/r_avatar/fad66207b103781e6c9f7d0a2258d440.png",
            "comment": "飚速2.5pro和强风st哪个好",
            "like_cnt": 0,
            "self_like": false,
            "is_self": 0,
            "create_at": "2023-11-11 22:43:26"
        },
        {
            "id": 113693,
            "uid": 70157375,
            "name": "虎扑JR1331795617",
            "avatar": "https://static.shihuocdn.cn/app/avatarbg/20200717/8d556609-b94d-4740-a454-656012b287f7.jpg",
            "comment": "篮球鞋",
            "like_cnt": 0,
            "self_like": false,
            "is_self": 0,
            "create_at": "2023-11-11 22:31:11"
        },
        {
            "id": 113692,
            "uid": 5313848283496560,
            "name": "迷糊uD5",
            "avatar": "https://static.shihuocdn.cn/third_avatar/nVqJnFoqKK86b7a2b53fad3e2bd455d2498b493760",
            "comment": "200至210，篮球鞋",
            "like_cnt": 0,
            "self_like": false,
            "is_self": 0,
            "create_at": "2023-11-11 21:47:20"
        },
        {
            "id": 113691,
            "uid": 4507289093046328,
            "name": "勾勾手f79",
            "avatar": "https://static.shihuocdn.cn/third_avatar/1fYKAj3Olrc120872f6e7db8c56fbe1e92e6434c00",
            "comment": "羽绒服",
            "like_cnt": 0,
            "self_like": false,
            "is_self": 0,
            "create_at": "2023-11-11 21:37:46"
        },
        {
            "id": 113690,
            "uid": 93972921,
            "name": "虎扑JR1163377499",
            "avatar": "https://static.shihuocdn.cn/user/avatar//20231105/1029x1029_9090BBEF-06D6-4B45-96F3-D83EE8DF698E.jpg",
            "comment": "2开nike休闲鞋",
            "like_cnt": 0,
            "self_like": false,
            "is_self": 0,
            "create_at": "2023-11-11 21:24:15"
        },
        {
            "id": 113689,
            "uid": 93972921,
            "name": "虎扑JR1163377499",
            "avatar": "https://static.shihuocdn.cn/user/avatar//20231105/1029x1029_9090BBEF-06D6-4B45-96F3-D83EE8DF698E.jpg",
            "comment": "2开nike休闲鞋",
            "like_cnt": 0,
            "self_like": false,
            "is_self": 0,
            "create_at": "2023-11-11 21:24:13"
        },
        {
            "id": 113688,
            "uid": 5345048479858875,
            "name": "阿飞d0C",
            "avatar": "https://static.shihuocdn.cn/third_avatar/66KYV7GK4213192b28c983351ab292da4d821a583b",
            "comment": "外套",
            "like_cnt": 0,
            "self_like": false,
            "is_self": 0,
            "create_at": "2023-11-11 21:10:18"
        },
        {
            "id": 113686,
            "uid": 82934192,
            "name": "虎扑JR1193105585",
            "avatar": "https://static.shihuocdn.cn/app/avatarbg/20220724/5ac2537c-8f4b-4b37-9378-bd5a5fe0413c.jpg",
            "comment": "毛衣",
            "like_cnt": 0,
            "self_like": false,
            "is_self": 0,
            "create_at": "2023-11-11 19:44:13"
        },
        {
            "id": 113685,
            "uid": 5082652021686369,
            "name": "当爱靠近50H",
            "avatar": "https://static.shihuocdn.cn/r_avatar/e813733120fa5cd333f37f5af713f72c.png",
            "comment": "2开篮球鞋推荐",
            "like_cnt": 0,
            "self_like": false,
            "is_self": 0,
            "create_at": "2023-11-11 19:38:50"
        },
        {
            "id": 113684,
            "uid": 5271916535873540,
            "name": "楚叔rN0",
            "avatar": "https://static.shihuocdn.cn/third_avatar/SiDdN6IiZp636fde9175a9b9a6e25cb8da7baa0b30",
            "comment": "后卫篮球鞋",
            "like_cnt": 0,
            "self_like": false,
            "is_self": 0,
            "create_at": "2023-11-11 19:38:33"
        },
        {
            "id": 113683,
            "uid": 5371588814012659,
            "name": "大名A38",
            "avatar": "https://static.shihuocdn.cn/r_avatar/598a821316823a681a334b38022b7861.png",
            "comment": "体重200的人可以穿什么跑鞋",
            "like_cnt": 0,
            "self_like": false,
            "is_self": 0,
            "create_at": "2023-11-11 19:29:00"
        }
    ]
    return staticUsers;
}

export default getStaticUsers;


// WEBPACK FOOTER //
// ./components/pipeline-pkRank/getStaticUsers.js